module.exports = __webpack_public_path__ + "static/media/totransmitEnable.06c00048.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/assets/images/totransmitEnable.png
// module id = 1333
// module chunks = 0